<template>
  <v-app style="position: relative">
    <SideBar style="z-index: 152" v-model="drawer" :expanded="expanded" :open="drawer" @update-state="updateDrawer" />
    <img src="../assets/menu-icon-close.svg" alt="" @click="expanded = !expanded" class="menu-icon"
      :style="expanded ? 'left: 264px' : 'left: 52px; transform: rotate(180deg);z-index: 200020'">
    <d-navbar style="z-index: 151; position:fixed; width: 100%; top: 0; background-color: #fff" @burger-clicked="openDrawer" />
    <v-main style="margin-top: 68px;">
      <slot></slot>
    </v-main>
    <support-component></support-component>
  </v-app>

</template>

<script>
import SideBar from "@/components/SideBar.vue";
import SupportComponent from "@/components/SupportComponent.vue";

export default {
  name: "LayoutContent",
  components: {
    SupportComponent,
    SideBar,
    DNavbar: () => import('@/components/DNavbar.vue')
  },
  data() {
    return {
      expanded: true,
      drawer: false,
    }
  },
  methods: {
    openDrawer() {
      this.drawer = true
    },
    updateDrawer(e) {
      this.drawer = e
    }
  }
}
</script>

<style scoped>
.menu-icon {
  position: fixed;
  top: 20px;
  z-index: 153;
  cursor: pointer;
  transition: 0.2s;
}

.menu-icon:hover {
  opacity: 0.8;
}

.menu-icon:active {
  opacity: 0.6;
}

@media(max-width: 1264px) {
  .menu-icon {
    display: none;
  }
}
</style>
